const toSnakeCase = (key) =>
  key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);

export function convertKeysToSnakeCase(input) {
  if (Array.isArray(input)) return input.map(convertKeysToSnakeCase);
  if (input !== null && typeof input === 'object') {
    return Object.fromEntries(
      Object.entries(input).map(([key, val]) => [
        toSnakeCase(key),
        convertKeysToSnakeCase(val),
      ])
    );
  }
  return input;
}
